// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("turbolinks").start();
require("@rails/ujs").start();
require("@rails/activestorage").start();
require("channels");
require('jquery');


import '../javascripts/axios_config';
import '../stylesheets/auto_completejs';
require('@tarekraafat/autocomplete.js');

// import "core-js/stable";
import "regenerator-runtime/runtime";

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
UIkit.use(Icons);

import '@fortawesome/fontawesome-free/js/all';

import '../javascripts/application';
import '../javascripts/topmenu';
import '../javascripts/dropdownjs';
import '../javascripts/loading';
import '../javascripts/suggestionForm';
import '../javascripts/file_upload';
import '../javascripts/intelligent_input';
import '../javascripts/sale_intelligent_input';
import '../javascripts/modal_support';
import '../javascripts/ajax_render';
import '../javascripts/auto_complete';
import '../javascripts/blog_textarea';

import '../stylesheets/application';
import '../stylesheets/css_topmenu';
import '../stylesheets/dropdownmenu';
import '../stylesheets/loading';
import '../stylesheets/algolia';
import '../stylesheets/file_upload';
import '../stylesheets/sidebar';
import '../stylesheets/fullcalendar';
import '../stylesheets/fullcalendar_mobile';
import '../stylesheets/fullcalendar_additional';
import '../stylesheets/kaminari';
import '../stylesheets/team';
import '../stylesheets/blog';
import '../stylesheets/items';
import '../stylesheets/scaffold';
import '../stylesheets/sale';
import '../stylesheets/customer';
import '../stylesheets/messages';
import '../stylesheets/line_account';
import '../stylesheets/linebot';
import '../stylesheets/chart';
import '../stylesheets/tag_relation';

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>) %> or the `imagePath` JavaScript helper below.

// $(document).on('turbolinks:load', function() {
//   $("#js-searchable").select2({
//     placeholder: "クリックして選択（文字を入力をすると検索できます）",
//     allowClear: true
//   })
// });


// document.addEventListener('turbolinks:load', () => {
//   $("#store_search").selectize({
//     placeholder: "Search...",
//     allowClear: true
//   });
// });



require.context('../images', true, /\.(png|jpg|jpeg|svg)$/);

var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
